import gridViewFieldsUtils from '../../utils/gridViewFieldsUtils';
import retainedValuesMixin from './retainedValuesMixin';
import formFieldInteractionMixin from './formFieldInteractionMixin';
import formFieldValidationMixin from './formFieldValidationMixin';
import { GeneralSettingsGetters } from '../../store/getters';
import { mapGetters } from 'vuex';
export default {
	props: {
		formField: Object,
		record: Object,
		tabIndex: Number,
		uniqueFields: Array,
		isBulkEdit: Boolean,
	},
	mixins: [
		retainedValuesMixin,
		formFieldInteractionMixin,
		formFieldValidationMixin,
	],
	computed: {
		...mapGetters({
			pkExeptionList: [GeneralSettingsGetters.PK_EXEPTION_LIST],
		}),
		gridViewFields() {
			if (!this.formField) return null;
			if (!this.formField.GridViewFields) return null;
			return this.formField.GridViewFields;
		},

		recordKeys() {
			if (!this.gridViewFields) return [];
			return this.gridViewFields.map((gv) =>
				gridViewFieldsUtils.getFieldName(gv)
			);
		},

		recordSelectedValue() {
			if (!this.record) return null;
			if (!this.recordKeys) return null;
			let value;
			let separator = this.formField.Separator || '/';
			this.recordKeys.forEach((key) => {
				if (!this.record[key]) return;
				if (value) {
					value = value + separator + this.record[key];
				} else {
					value = this.record[key];
				}
			});
			return value;
		},

		enforceUppercase() {
			if (!this.formField) return false;
			if (this.formField.Uppercase) return true;
			return false;
		},
		getUppercaseClass() {
			if (this.enforceUppercase) {
				return 'uppercase';
			}
			return '';
		},
		loadPk() {
			let result = true;
			this.pkExeptionList.forEach((x) => {
				if (x == this.selectedValue) {
					result = false;
				}
			});
			return result;
		},
	},
	data() {
		return {
			selectedValue: undefined,
			skipNextRecordUpdate: false,
		};
	},

	watch: {
		setValue(newVal) {
			this.selectedValue = newVal;
		},
		record() {
			if (this.skipNextRecordUpdate) {
				this.skipNextRecordUpdate = false;
				return;
			}

			this.onRecordChanged();
		},

		selectedValue(newVal, oldVal) {
			if (newVal === true) {
				this.updateValidationRules();
				this.onSelectedValueChanged(newVal);
			} else {
				if (
					newVal &&
					oldVal === undefined &&
					newVal == this.recordSelectedValue
				) {
					return;
				}
				this.updateValidationRules();
				this.onSelectedValueChanged(newVal);
			}
		},
	},
	mounted() {
		this.visible = this.formField.IsVisible;
	},
	methods: {
		uppercase() {
			//check if formField force upper case
			if (!this.enforceUppercase) return;
			if (this.selectedValue) {
				this.selectedValue = this.selectedValue.toUpperCase();
			}
		},
	},
};
